import { lazy } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";

import { pageNames } from "@shared/routes/pageNames";

function HomeRedirect() {
	const { search } = useLocation();
	return <Navigate to={`${pageNames.signin.path}${search}`} />;
}

const ACPSignIn = lazy(() => import("@admission/pages/ACP/SignIn"));
const ACPSignUp = lazy(() => import("@admission/pages/ACP/SignUp"));
const ACPRecoveryPassword = lazy(
	() => import("@admission/pages/ACP/RecoveryPassword"),
);
const ACPResetPassword = lazy(
	() => import("@admission/pages/ACP/ResetPassword"),
);
const ACPSignUpNCADCompleted = lazy(
	() => import("@admission/pages/ACP/SignUpNCADCompleted"),
);
const ACPSignUpPartnerCompleted = lazy(
	() => import("@admission/pages/ACP/SignUpPartnerCompleted"),
);
const ACPTesteIframe = lazy(() => import("@admission/pages/ACP/TesteIframe"));
const ACPInvalidSignUpKBA = lazy(
	() => import("@admission/pages/ACP/Error/InvalidSignUpKBA"),
);
const ACPBlockedSignUpKBA = lazy(
	() => import("@admission/pages/ACP/Error/BlockedSignUpKBA"),
);
const ACPBlockedSignUpLGPD = lazy(
	() => import("@admission/pages/ACP/Error/BlockedSignUpLGPD"),
);
const ACPInvalidRecoveryPasswordKBA = lazy(
	() => import("@admission/pages/ACP/Error/InvalidRecoveryPasswordKBA"),
);
const ACPBlockedRecoveryPasswordKBA = lazy(
	() => import("@admission/pages/ACP/Error/BlockedRecoveryPasswordKBA"),
);
const ACPInvalidResetPasswordKBA = lazy(
	() => import("@admission/pages/ACP/Error/InvalidResetPasswordKBA"),
);
const ACPBlockedResetPasswordKBA = lazy(
	() => import("@admission/pages/ACP/Error/BlockedResetPasswordKBA"),
);
const ACPBlockedSignIn = lazy(
	() => import("@admission/pages/ACP/Error/BlockedSignIn"),
);

const ACPValidateConflictingEmail = lazy(
	() => import("@admission/pages/ACP/ValidateConflictingEmail"),
);
const ACPPublicEmailConfirmation = lazy(
	() => import("@admission/pages/ACP/PublicEmailConfirmation"),
);
const ACPSignUpNCAD = lazy(() => import("@admission/pages/ACP/SignUpNCAD"));

const UpdateContactSuccessACP = lazy(
	() => import("@admission/pages/ACP/Success/UpdateContact"),
);
const UpdatePasswordSuccessACP = lazy(
	() => import("@admission/pages/ACP/Success/UpdatePassword"),
);
const UnlockProtectedFeatureACP = lazy(
	() => import("@admission/pages/ACP/UnlockProtectedFeature"),
);
const UnlockProtectedFeatureSuccessACP = lazy(
	() => import("@admission/pages/ACP/Success/UnlockProtectedFeature"),
);
const UnlockProtectedFeatureRecoveryPasswordACP = lazy(
	() => import("@admission/pages/ACP/UnlockProtectedFeatureRecoveryPassword"),
);

const UnlockProtectedFeatureInvalidKbaACP = lazy(
	() => import("@admission/pages/ACP/Error/UnlockProtectedFeatureInvalidKBA"),
);
const UnlockProtectedFeatureBlockedKbaACP = lazy(
	() => import("@admission/pages/ACP/Error/UnlockProtectedFeatureBlockedKBA"),
);

const ACPSignInUnifyPassword = lazy(
	() => import("@admission/pages/ACP/SignInUnifyPassword"),
);

const ACPMFAPositiveData = lazy(
	() => import("@admission/pages/ACP/MFAPositiveData"),
);

export function PublicRouter() {
	return (
		<>
			<Route path={pageNames.home.path} element={<HomeRedirect />} />

			<Route path={pageNames.signin.path} element={<ACPSignIn />} />

			<Route path={pageNames.signup.path} element={<ACPSignUp />} />
			<Route path={pageNames.signUpNCAD.path} element={<ACPSignUpNCAD />} />

			<Route path={pageNames.testeIframe.path} element={<ACPTesteIframe />} />

			<Route
				path={pageNames.signupNCADCompleted.path}
				element={<ACPSignUpNCADCompleted />}
			/>
			<Route
				path={pageNames.signUpPartnerCompleted.path}
				element={<ACPSignUpPartnerCompleted />}
			/>
			<Route
				path={pageNames.signupACPErrorKBA.path}
				element={<ACPInvalidSignUpKBA />}
			/>
			<Route
				path={pageNames.signupACPBlockedKBA.path}
				element={<ACPBlockedSignUpKBA />}
			/>
			<Route
				path={pageNames.signupACPBlockedLGPD.path}
				element={<ACPBlockedSignUpLGPD />}
			/>
			<Route
				path={pageNames.recoveryPasswordACPInvalidKBA.path}
				element={<ACPInvalidRecoveryPasswordKBA />}
			/>
			<Route
				path={pageNames.recoveryPasswordACPBlockedKBA.path}
				element={<ACPBlockedRecoveryPasswordKBA />}
			/>
			<Route
				path={pageNames.resetPasswordACPInvalidKBA.path}
				element={<ACPInvalidResetPasswordKBA />}
			/>
			<Route
				path={pageNames.resetPasswordACPBlockedKBA.path}
				element={<ACPBlockedResetPasswordKBA />}
			/>
			<Route
				path={pageNames.signinACPFailedDocument.path}
				element={<ACPBlockedSignIn />}
			/>
			<Route
				path={pageNames.recoveryPassword.path}
				element={<ACPRecoveryPassword />}
			/>
			<Route
				path={pageNames.redefinePassword.path}
				element={<ACPResetPassword />}
			/>
			<Route
				path={pageNames.validateConflictingEmailACP.path}
				element={<ACPValidateConflictingEmail />}
			/>
			<Route
				path={pageNames.publicEmailConfirmation.path}
				element={<ACPPublicEmailConfirmation />}
			/>
		</>
	);
}

export function PrivateRouter() {
	return (
		<>
			<Route
				path={pageNames.signinUnifyPasswordACP.path}
				element={<ACPSignInUnifyPassword />}
			/>
			<Route
				path={pageNames.updateContactSuccess.path}
				element={<UpdateContactSuccessACP />}
			/>
			<Route
				path={pageNames.updatePasswordSuccess.path}
				element={<UpdatePasswordSuccessACP />}
			/>
			<Route
				path={pageNames.unlockProtectedFeature.path}
				element={<UnlockProtectedFeatureACP />}
			/>
			<Route
				path={pageNames.unlockProtectedFeatureSuccess.path}
				element={<UnlockProtectedFeatureSuccessACP />}
			/>
			<Route
				path={pageNames.unlockProtectedFeaturePassword.path}
				element={<UnlockProtectedFeatureRecoveryPasswordACP />}
			/>
			<Route
				path={pageNames.unlockProtectedFeatureACPInvalidKBA.path}
				element={<UnlockProtectedFeatureInvalidKbaACP />}
			/>
			<Route
				path={pageNames.unlockProtectedFeatureACPBlockedKBA.path}
				element={<UnlockProtectedFeatureBlockedKbaACP />}
			/>
			<Route
				path={pageNames.mfaPositiveData.path}
				element={<ACPMFAPositiveData />}
			/>
		</>
	);
}
